import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Centered, Loader } from '../components/common';
import { H3 } from '../components/common/preflighted';
import { useTheme } from '../components/common/providers/DialectThemeProvider';
const LoadingThread = () => {
    const { textStyles } = useTheme();
    return (_jsx(Centered, { children: _jsxs(H3, { className: clsx(textStyles.header, 'dt-flex dt-items-center dt-mb-1'), children: [_jsx(Loader, { className: "dt-mr-2" }), " Loading notifications"] }) }));
};
export default LoadingThread;
//# sourceMappingURL=LoadingThread.js.map